// src/Pages/contact-info/ContactInfo.jsx

import React from "react";
import "../../profile.css";
import { ChevronRight, FileText, Shield, Info, HelpCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ContactInfo = () => {
  const navigate = useNavigate();

  const pages = [
    {
      title: "Terms & Conditions",
      icon: <FileText size={18} />,
      path: "/contact-info/terms-conditions",
    },
    {
      title: "Privacy Policies",
      icon: <Shield size={18} />,
      path: "/contact-info/privacy-policy",
    },
    {
      title: "About Us",
      icon: <Info size={18} />,
      path: "/contact-info/about-us",
    },
    {
      title: "FAQ’s",
      icon: <HelpCircle size={18} />,
      path: "/contact-info/faqs",
    },
  ];

  return (
    <div className="contact-info-page">
      <h2>More Info & Contact</h2>

      <div className="contact-info-list">
        {pages.map((item, index) => (
          <div
            className="contact-info-card"
            key={index}
            onClick={() => navigate(item.path)}
          >
            <div className="left">
              <div className="icon-box">{item.icon}</div>
              <span>{item.title}</span>
            </div>

            <ChevronRight size={20} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;